const usersEn = {
    profile: require('../../lang/en/users/Profile').default,
    customer: require('../../lang/en/users/Customer').default,
    member: require('../../lang/en/users/Member').default,
    agronomy: require('../../lang/en/users/Agronomy').default,
    supervisor: require('../../lang/en/users/Supervisor').default,
    staff: require('../../lang/en/users/Staff').default,
};

export default usersEn;